import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { ArrowCounterClockwise } from "@phosphor-icons/react";
import { fmtDate } from "./adminUtils";

export function DeletedTab({ deleted, loading, onRestore }) {
  return (
    <div data-testid="admin-deleted-tab">
      <p className="text-sm text-zinc-400 mb-4">
        Deleted accounts are archived and fully recoverable for <span className="text-zinc-200">30 days</span>, then permanently purged.
      </p>
      {loading ? (
        <div className="text-zinc-500 font-mono text-sm animate-pulse">Loading…</div>
      ) : deleted.length === 0 ? (
        <div className="border border-white/10 rounded-lg px-5 py-12 text-center text-sm text-zinc-500">
          Nothing here. Deleted accounts will appear for 30 days.
        </div>
      ) : (
        <div className="border border-white/10 rounded-lg overflow-hidden">
          <div className="grid grid-cols-12 px-5 py-3 border-b border-white/10 bg-zinc-900/60 font-mono text-xs uppercase tracking-wider text-zinc-500">
            <div className="col-span-4">Account</div>
            <div className="col-span-2 hidden sm:block">Deleted</div>
            <div className="col-span-3 hidden sm:block">Deleted by</div>
            <div className="col-span-2 sm:col-span-1">Purge</div>
            <div className="col-span-8 sm:col-span-2 text-right">Action</div>
          </div>
          {deleted.map((d) => (
            <div key={d.user_id} data-testid={`admin-deleted-${d.user_id}`} className="grid grid-cols-12 items-center px-5 py-4 border-b border-white/10 last:border-0 hover:bg-zinc-900/40 transition-colors">
              <div className="col-span-4 flex items-center gap-3 min-w-0">
                <Avatar className="w-9 h-9">
                  <AvatarImage src={d.picture} />
                  <AvatarFallback className="bg-zinc-800 text-xs">{d.name?.[0] || d.email?.[0]}</AvatarFallback>
                </Avatar>
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate">{d.name || d.email}</div>
                  <div className="font-mono text-xs text-zinc-500 truncate">{d.email}</div>
                  <div className="font-mono text-[10px] text-zinc-600">{d.orgs_count || 0} workspaces · {d.machines_count || 0} machines</div>
                </div>
              </div>
              <div className="col-span-2 hidden sm:block text-sm text-zinc-400">{fmtDate(d.deleted_at)}</div>
              <div className="col-span-3 hidden sm:block text-sm text-zinc-400 truncate">{d.deleted_by}</div>
              <div className="col-span-2 sm:col-span-1">
                <span className={`text-xs font-mono ${d.days_remaining <= 3 ? "text-red-400" : "text-zinc-400"}`}>
                  {d.days_remaining}d
                </span>
              </div>
              <div className="col-span-8 sm:col-span-2 flex justify-end">
                <Button
                  data-testid={`admin-restore-${d.user_id}`}
                  size="sm"
                  variant="outline"
                  onClick={() => onRestore(d)}
                  className="bg-black border-zinc-800 hover:border-emerald-600 hover:text-emerald-400 gap-1.5"
                >
                  <ArrowCounterClockwise size={14} /> Restore
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
